import { render, staticRenderFns } from "./HeaderHomeFour.vue?vue&type=template&id=46837a97&"
import script from "./HeaderHomeFour.vue?vue&type=script&lang=js&"
export * from "./HeaderHomeFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports